var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 555 891",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50.013%",
    x2: "50.013%",
    y1: "100.007%",
    y2: ".007%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FC4D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#F7E21E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "100.012%",
    x2: "-.038%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#FFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "100.028%",
    x2: "-.038%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#FFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "100.045%",
    x2: "-.038%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#FFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "99.915%",
    x2: "-.032%",
    y1: "50.005%",
    y2: "50.005%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#91CAE2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "5.286%",
    stopColor: "#9ACEE4",
    stopOpacity: 0.478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24.22%",
    stopColor: "#BEE0EE",
    stopOpacity: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.28%",
    stopColor: "#DBEDF5",
    stopOpacity: 0.286
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62.28%",
    stopColor: "#EFF7FB",
    stopOpacity: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.22%",
    stopColor: "#FBFDFE",
    stopOpacity: 0.095
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "99.99%",
    x2: "-.01%",
    y1: "50.018%",
    y2: "50.018%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#91CAE2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38.17%",
    stopColor: "#BCDFED",
    stopOpacity: 0.312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "100.017%",
    x2: ".023%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#91CAE2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38.17%",
    stopColor: "#BCDFED",
    stopOpacity: 0.312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m244.8 87.2-18.2 27.7-10.9-31.4-32-8.8 26.4-20-1.5-33.2 27.3 19L267 28.8l-9.7 31.8L278 86.5z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m3.7 53.7 32 8.8 10.9 31.4L64 67.5l.8-1.3 33.2-.7-20.7-25.9L87 7.8 55.9 19.5 28.6.5l.1.5 1.4 32.7z",
    transform: "translate(183)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m3.7 53.7 32 8.8 10.9 31.4L64 67.5 28.7 1l1.4 32.7z",
    opacity: 0.56,
    transform: "translate(183)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m78.8 200.2-18.2 27.7-10.9-31.4-32-8.8 26.4-20-1.5-33.2 27.3 19 31.1-11.7-9.7 31.8 20.7 25.9z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m2.7 53.7 32 8.8 10.9 31.4 17.2-26.1 1-1.6 33.2-.7-20.7-25.9L86 7.8 54.9 19.5 27.6.5l.1 1.2 1.4 32z",
    transform: "translate(17 113)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m2.7 53.7 32 8.8 10.9 31.4 17.2-26.1L27.7 1.7l1.4 32z",
    opacity: 0.56,
    transform: "translate(17 113)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m465.8 106.2-18.2 27.7-10.9-31.4-32-8.8 26.4-20-1.5-33.2 27.3 19L488 47.8l-9.7 31.8 20.7 25.9z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m3.7 53.7 32 8.8 10.9 31.4 17-25.9 1.2-1.8 33.2-.7-20.7-25.9L87 7.8 55.9 19.5 28.6.5l.1 1.9 1.4 31.3z",
    transform: "translate(404 18)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m3.7 53.7 32 8.8 10.9 31.4 17-25.9L28.7 2.4l1.4 31.3z",
    opacity: 0.56,
    transform: "translate(404 18)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    opacity: 0.1,
    transform: "translate(0 179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.4 148v.4c.2 9.5 6.6 17.8 15.7 20.4 118.4 33.7 189 73.4 231.1 108.9 50.1 42.2 59.4 115.3 22 169C190.3 560 67.4 619 24.6 635.4c-4.3 1.7-7.8 4.5-10.3 8.1-1.4 2-2.5 4.3-3.1 6.7-.5 1.9-.8 3.8-.8 5.8 0 3.3.7 6.5 2 9.2 4.2 9.2 14.5 14.8 25.2 12.4 227.6-52.4 343.8-189.3 402.5-326.9 56.2-131.7 59.6-264 57.7-323.2-.5-14.2-11.4-25.3-24.8-26.7-2.6-.3-5.3-.2-8 .3-12.7 2.3-22.1 13.1-22.7 25.9-5.4 112.6-33.6 174.7-54 205.6-9.8 14.8-30.1 18.3-44.4 7.8C242.8 166.2 86 135.8 25.5 126.4c-1.1-.2-2.3-.3-3.4-.3C10.2 126.4.4 135.9.4 148m376.8 345.7s83.7 68.7 117.6 205.6c2.5 10.1 12.3 13.5 20.3 11.7 7-1.6 13.1-7.3 13.2-16.5.9-84.9-14.2-202.4-85.4-308.4 0 0-10.2 28.2-31.6 62.2-9.3 14.6-20.6 30.4-34.1 45.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.3,
    cy: 103.2,
    r: 61.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.3 353.2 86.8-2.3c56.2-131.7 59.6-264 57.7-323.2C497.3 13.5 486.4 2.4 473 1c-.6 59.2-9.2 297.4-119.7 352.2m-84.1 93.5C190.3 560 67.4 619 24.6 635.4c-4.3 1.7-7.8 4.5-10.3 8.1-1.4 2-2.5 4.3-3.1 6.7l1.2 15.1c178.2-63.5 263.3-148.1 303.9-213.2 40.6-65.2 25.1-150.5-35.4-197.7-86.5-67.6-220.6-96.1-280.5-106 .2 9.5 6.6 17.8 15.7 20.4 118.4 33.7 189 73.4 231.1 108.9 50.1 42.2 59.4 115.3 22 169m141.8 2.2C495.5 531 514 701 515.1 711c7-1.6 13.1-7.3 13.2-16.5.9-84.9-14.2-202.4-85.4-308.4 0 0-10.2 28.2-31.6 62.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 174)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.4 148v.4c.2 9.5 6.6 17.8 15.7 20.4 118.4 33.7 189 73.4 231.1 108.9 50.1 42.2 59.4 115.3 22 169C190.3 560 67.4 619 24.6 635.4c-4.3 1.7-7.8 4.5-10.3 8.1-1.4 2-2.5 4.3-3.1 6.7-.5 1.9-.8 3.8-.8 5.8 0 3.3.7 6.5 2 9.2 4.2 9.2 14.5 14.8 25.2 12.4 227.6-52.4 343.8-189.3 402.5-326.9 56.2-131.7 59.6-264 57.7-323.2-.5-14.2-11.4-25.3-24.8-26.7-2.6-.3-5.3-.2-8 .3-12.7 2.3-22.1 13.1-22.7 25.9-5.4 112.6-33.6 174.7-54 205.6-9.8 14.8-30.1 18.3-44.4 7.8C242.8 166.2 86 135.8 25.5 126.4c-1.1-.2-2.3-.3-3.4-.3C10.2 126.4.4 135.9.4 148m376.8 345.7s83.7 68.7 117.6 205.6c2.5 10.1 12.3 13.5 20.3 11.7 7-1.6 13.1-7.3 13.2-16.5.9-84.9-14.2-202.4-85.4-308.4 0 0-10.2 28.2-31.6 62.2-9.3 14.6-20.6 30.4-34.1 45.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.3,
    cy: 103.2,
    r: 61.8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m353.3 353.2 86.8-2.3c56.2-131.7 59.6-264 57.7-323.2C497.3 13.5 486.4 2.4 473 1c-.6 59.2-9.2 297.4-119.7 352.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M269.2 446.7C190.3 560 67.4 619 24.6 635.4c-4.3 1.7-7.8 4.5-10.3 8.1-1.4 2-2.5 4.3-3.1 6.7l1.2 15.1c178.2-63.5 263.3-148.1 303.9-213.2 40.6-65.2 25.1-150.5-35.4-197.7-86.5-67.6-220.6-96.1-280.5-106 .2 9.5 6.6 17.8 15.7 20.4 118.4 33.7 189 73.4 231.1 108.9 50.1 42.2 59.4 115.3 22 169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M411 448.9C495.5 531 514 701 515.1 711c7-1.6 13.1-7.3 13.2-16.5.9-84.9-14.2-202.4-85.4-308.4 0 0-10.2 28.2-31.6 62.2z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export default ForwardRef;